// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:29:41

export default {
  "id": "robbotto",
  "slug": "robbotto",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1e7260dfc47e4a5c81818c9f569e979b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1e7260dfc47e4a5c81818c9f569e979b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Robbotto",
      "description": "Robbotto is an arcade platformer with a retro esthetic. Play alone or with a friend as you travel through the ship defeating all the enemies.",
      "instructions": "Use the arrow keys to navigate the menu. Enter to select.",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "2d",
        "arcade",
        "co-op",
        "platformer",
        "retro"
      ]
    },
    "zh-CN": {
      "title": "罗博托",
      "description": "Robbotto是一款具有复古美学的街机平台游戏。您可以独自或与朋友一起游玩，在飞船中击败所有敌人。",
      "instructions": "使用箭头键导航菜单。按Enter键选择。",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "2D",
        "街机",
        "合作",
        "平台",
        "复古"
      ]
    },
    "zh-TW": {
      "title": "羅博托",
      "description": "Robbotto 是一款復古風格的街機平台遊戲。您可以獨自或與朋友一起遊玩，在遊過船艙時擊敗所有敵人。",
      "instructions": "使用方向鍵在選單中導航。按Enter鍵選擇。",
      "genres": [
        "冒險",
        "敏捷"
      ],
      "tags": [
        "2D",
        "街機",
        "合作",
        "平台遊戲",
        "復古"
      ]
    },
    "zh-HK": {
      "title": "羅波托",
      "description": "Robbotto是一款具有復古美學的街機平台遊戲。您可以獨自或與朋友一起遊玩，在旅途中穿越船隻，擊敗所有敵人。",
      "instructions": "使用方向鍵選擇菜單。按Enter選擇。",
      "genres": [
        "冒險",
        "靈巧"
      ],
      "tags": [
        "2D",
        "街機",
        "合作",
        "平台遊戲",
        "復古"
      ]
    },
    "ja": {
      "title": "ロボットト",
      "description": "ロボットはレトロな美学を持つアーケードプラットフォームゲームです。一人でも友人と一緒でも、船を通って敵を倒しながら旅を進めましょう。",
      "instructions": "メニューをナビゲートするには矢印キーを使用してください。選択するには、Enterキーを押してください。",
      "genres": [
        "冒険",
        "敏捷性"
      ],
      "tags": [
        "2D",
        "アーケード",
        "コラボレーション",
        "プラットフォーム",
        "レトロ"
      ]
    },
    "ko": {
      "title": "로봇토",
      "description": "로봇토는 레트로 스타일의 아케이드 플랫폼 게임입니다. 혼자든 친구와 함께 배를 통해 적을 모두 물리치며 여행하세요.",
      "instructions": "아래키를 사용하여 메뉴를 탐색하세요. 엔터키를 눌러 선택하세요.",
      "genres": [
        "모험",
        "유연성"
      ],
      "tags": [
        "2D",
        "아케이드",
        "협동 플랫폼",
        "레트로"
      ]
    },
    "fr": {
      "title": "Robbotto",
      "description": "Robbotto est un plate-formiste d'arcade aux esthétiques rétro. Jouez seul ou avec un ami en parcourant le navire et en vainquant tous les ennemis.",
      "instructions": "Utilisez les touches flèches pour naviguer dans le menu. Appuyez sur Entrée pour sélectionner.",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "2D",
        "arcade",
        "coopération",
        "plate-forme",
        "retro"
      ]
    }
  }
};
